import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import useHandleErrorFields from "../../../../../../hooks/useHandleErrorFields";
import {Commune} from "../../../../../../app/models/Commune";
import {Region} from "../../../../../../app/models/Region";
import {Country} from "../../../../../../app/models/Country";
import {Event} from "../../../../../../app/models/Event";
import CountriesFormDefault from "../../../../../../components/default/CountriesFormDefault";
import InputImageRounded from "../../../../../../components/inputs/InputImageRounded";

type Props = {
    eventDataForm: Event;
    setEventDataForm: (Event: Event) => void;

    countries: Country[];
    regions: Region[];
    communes: Commune[];
    setRegions: (regions: Region[]) => void;
    setCommunes: (communes: Commune[]) => void;

    errorFields?: any;
};

const EventFormEdit = ({ eventDataForm, setEventDataForm, errorFields,    countries,
    regions,
    communes,
    setRegions,
    setCommunes }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const defaultImage = "https://media.istockphoto.com/id/1354776450/vector/no-photo-available-vector-icon-default-image-symbol-picture-coming-soon-for-web-site-or.jpg?s=612x612&w=0&k=20&c=sE9bs1rjaBAZ5hO9WZ1JH_ItWjZaMih2zE9ig0GraWY=";
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);
    
    
    const [image, setImage] = useState(
        eventDataForm.image
            ? eventDataForm.image
            : defaultImage
    );
    
    
    const dataOnChangeImages = (e: any) => {
        const selectedFile = e.target.files[0];
        console.log(selectedFile);
        if (selectedFile) {
            setImage(URL.createObjectURL(selectedFile));
            setEventDataForm({
                ...eventDataForm,
                [e.target.name]: selectedFile
            });
        }
    };

    const removeImage = () => {
        setImage(
            defaultImage
        ); // Limpiar el estado de la imagen
        setEventDataForm({
            ...eventDataForm,
            image: undefined // Limpiar la propiedad image en el estado del formulario
        });
        const fileInput = document.getElementById('image') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    };
    const handleChange = (
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setEventDataForm({ ...eventDataForm, [name]: value });
    };

    const handleChangeDescription = (value: string) => {
        setEventDataForm({ ...eventDataForm, description: String(value) });
    }

    const handleChangeSelectTwo = (name: string, value: number | string | null | undefined) => {
        const obj = { [name]: value };
        if (name == 'region_id' && value == undefined) {
            obj.commune_id = undefined;
            setCommunes([]);
        } else if (name == 'country_id' && value == undefined) {
            obj.region_id = undefined;
            obj.commune_id = undefined;
            setRegions([]);
        }
        setEventDataForm({ ...eventDataForm, ...obj });
    };

    useEffect(() => {
        setImage(eventDataForm.image ? eventDataForm.image : defaultImage);
    }, [eventDataForm.image]);

    return (
        <>
            <div className="mb-2 row">
                <InputImageRounded image={image} handleChange={dataOnChangeImages} removeImage={removeImage} imageSelected={eventDataForm.image} name={"image"} id={"eventEditAvatar"}/>
                <div className="invalid-feedback" style={{ display: 'flex' }}>
                    {fieldErrorMessage('image')}
                </div>
            </div>
            <div className="mb-2 row needs-validation">
                <div className="col-md-6">
                    <label className="col-form-label">Titulo</label>

                    <input
                        name="title"
                        id="title"
                        type="text"
                        className={`form-control ${fieldHasError('title')}`}
                        value={eventDataForm.title}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('title')}
                        placeholder="Ingrese el nombre de Evento"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('title')}
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="col-form-label">Tipo de evento</label>
                    <select
                        className={`form-control ${fieldHasError('event_type')}`}
                        name="event_type"
                        id="event_type"
                        value={eventDataForm.event_type}
                        onChange={handleChange}
                    >
                        <option>Presencial</option>
                        <option>Remoto</option>
                    </select>
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('event_type')}
                    </div>
                </div>
                    <CountriesFormDefault
                        countries={countries}
                        communes={communes}
                        dataForm={eventDataForm}
                        fieldErrorMessage={fieldErrorMessage}
                        fieldHasError={fieldHasError}
                        handleChange={handleChange}
                        handleChangeSelectTwo={handleChangeSelectTwo}
                        onFocusRemove={onFocusRemove}
                        regions={regions}
                    />

                <div className="col-md-12">
                    <label className="col-form-label">Dirección</label>
                    <input
                        name="address"
                        id="address"
                        type="text"
                        className={`form-control ${fieldHasError('address')}`}
                        value={eventDataForm.address}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('address')}
                        placeholder="Ingrese la dirección"
                    />
                </div>
                <div className="col-md-12 mt-2">
                    <label className="col-form-label">Descripción</label>
                    <ReactQuill value={eventDataForm.description} onChange={handleChangeDescription}
                                className={`${fieldHasError('description')}`}
                    placeholder="Ingrese una descripción"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('description')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default EventFormEdit;
